(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["image-gallery"] && !window.DesignMode) return;
  try {
    
(function($) {
	//Don't need to load in the Admin (it's better to show the Title and its content since you can't click)
	$('div.gallery').each(function() {
		$(this).magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true,
				navigateByImgClick: true,
				preload: [0,1]
			}
		});
	});
})(jQuery);

  } catch(e) { console.error(e); }
})();

})();
